import { useLocalStorage } from '@rehooks/local-storage';
import type { FC, ReactNode } from 'react';

import LegacyAccordion from '@app/components/LegacyAccordion';

import { ExportContainer } from './styles';

type LocalStorageProjectKey = { [key: string]: boolean };

interface ExportAccordionProps {
    heading: ReactNode;
    name: string;
    projectId: string;
    initiallyExpanded?: boolean;
    onClick?: (value: boolean) => void;
    children: ReactNode;
}

const ExportAccordion: FC<ExportAccordionProps> = ({
    children,
    heading,
    name,
    projectId,
    initiallyExpanded = false,
    onClick,
}) => {
    const localStorageKey = `export-page-accordion-${projectId}`;

    const [expandedLocalStorageState, setExpandedLocalStorageState] = useLocalStorage<LocalStorageProjectKey>(
        localStorageKey,
        {},
    );

    // We are using const instead of useState because we don't need to save this value.
    // We already using the useLocalStorage for that
    const expanded = expandedLocalStorageState[name] ?? initiallyExpanded;

    const onToggle = (opened: boolean) => {
        setExpandedLocalStorageState({
            ...expandedLocalStorageState,
            [name]: opened,
        });
        onClick?.(opened);
    };

    return (
        <ExportContainer>
            <LegacyAccordion
                title={heading}
                onToggle={onToggle}
                initiallyExpanded={expanded}
                noBorder
                iconPosition="left"
            >
                {expanded && children}
            </LegacyAccordion>
        </ExportContainer>
    );
};

export default ExportAccordion;
